module.exports = __webpack_public_path__ + "static/neotenites-6b5beea8853a07bdc843111c9cf5e454.svg";